
// Actions
const PREFIX = 'calculus/database/';

export const SET_DATABASEDATE  = PREFIX + 'SET_DATABASEDATE';

const INITIAL_STATE = {
  loading: true,
  data: []
};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_DATABASEDATE:
      return {
        ...state,
        data: payload,
        loading: false
      };

    default:
      return state;
  }
}

// Action Creators
export function setDatabaseDate(payload) {
  return {
    type: SET_DATABASEDATE,
    payload: payload
  };
}
